import { Component, OnInit,Input,Output,EventEmitter, ViewChild} from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
// import { FormGroup, FormBuilder, Validators, FormControl, NgForm } from '@angular/forms';
import { AlertService, ProductService,AppService } from '../_services/index';
// import $ from 'jquery/dist/jquery';
import {NgbModal, NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import { appConfig } from '../app.config';

class product {
  id: number;
  category: number;
  purchase_price: number;
  selling_price: number;
  sub_category: number;
  stock_quantity: number;
  damagedQuantity: number;
  name: string;
  status: number;
  note: string;
}

@Component({
  selector: 'app-product',
  templateUrl: './product.component.html'
})
export class ProductComponent implements OnInit {
  @Input() allowMultiple: boolean;
  @Input() fileType: string;
  @Input() required: boolean;
  @Input() maxSizeInKb: number;
  @Output() onSelection = new EventEmitter<FileList>();
  DisplayedText: string = "";
  fileList:any;
  pdf = false;
  exl = false;
  dtOptions: DataTables.Settings = {}; //  DataTable
  dtTrigger = new Subject(); //  DataTable
  productList: product[] = []; // Table Data list
  // productAddForm: FormGroup;
  randomnumber = Math.floor(Math.random() * 100000000);
  getProduct = {
    id:'',
    serial_number:'',
    name: '',
    category_id: '',
    sub_category_id: '',
    purchase_price: '',
    selling_price: '',
    note: '',
    status: '',
    image: ''
  };
  closeResult: string; // Modal Close
  productInfo = {
    id:'',
    serial_number:'',
    name:'',
    category:'',
    subCategory:'',
    purchase_price:'',
    selling_price:'',
    stock_quantity:'',
    note:'',
    status:'',
    image:''
  };
  constructor(
              public router: Router,
              private dataService:ProductService,
              private alertService: AlertService,
              private AppService: AppService,
              private modalService: NgbModal
            ) { }
  
  product = {
    id:'',
    serial_number:'',
    name: '',
    category: '',
    subCategory: '',
    purchase_price: '',
    selling_price: '',
    note: '',
    status: '',
    image: ''
  };
  modalReference:NgbActiveModal;
  modalTitle:string;
  cat = {};
  subCat:any[] = [];
  setting = {currency:''};
  showloding = true;
  lodingImage = false;
  ngOnInit() {
    this.allProduct();

    this.dataService.getCategory()
        .pipe().subscribe(data => { this.cat = data['cat'];
    });
    let settingData = JSON.parse(localStorage.getItem('setting'));
    this.setting = {currency:settingData.currency};
  }

  allProduct(){
    this.loadShow();
    this.dataService.getAllProduct()
        .pipe().subscribe(
          data => { this.productList = data['product']; 
          this.dtTrigger.next(); // Data Table
          this.pdf = true;
          this.exl = true;
          this.loadHide();
        });
  }

  selectCat(id){
    this.dataService.getSubCategory(id)
        .pipe().subscribe(data => { 
                this.subCat = data['subCat'];
        });
  }
  open(content) {
    // this.formName.reset();
    if (this.getProduct.id !=null) {
      this.getProduct.id='';
    }

    this.randomnumber = Math.floor(Math.random() * 100000000);
    this.product.serial_number = String(this.randomnumber);
    this.product.name = '';
    this.product.note = '';
    this.product.purchase_price = '';
    this.product.selling_price = '';
    this.product.category = '';
    this.product.subCategory = '';
    this.product.status = '1';
    this.product.image = '';

    this.DisplayedText = '';
    this.modalTitle = "Add Product";
    this.modalReference = this.modalService.open(content);

  }

	save(val){
		this.insertAction(val);
	}

	edit(id,content){
    this.loadShow();
    this.DisplayedText = '';
    	this.dataService.getProduct(id)
          .subscribe(data => { this.getProduct = data['product']; 
              let sub_category_id;
              if(this.getProduct.sub_category_id==null){
                sub_category_id ='';
              }else{
                sub_category_id = this.getProduct.sub_category_id;
                this.selectCat(sub_category_id);
              }
              this.product = {
                    id:this.getProduct.id,
                    serial_number:String(this.getProduct.serial_number),
                    name:this.getProduct.name,
                    category:this.getProduct.category_id,
                    subCategory:sub_category_id,
                    purchase_price:this.getProduct.purchase_price,
                    selling_price:this.getProduct.selling_price,
                    note:this.getProduct.note,
                    status:this.getProduct.status,
                    image:this.getProduct.image
              };
              this.loadHide();
              this.modalTitle = "Edit Product";
              this.modalReference = this.modalService.open(content);
            });

	}

  openProductInfoMdal(id,customerinfo){
    this.loadShow();
    this.productInfo.image = '';
    this.dataService.getProductInfo(id)
        .pipe().subscribe(data => {
                let product = data['product'];
                    this.productInfo = {
                      id:product.id,
                      serial_number:product.serial_number,
                      name:product.name,
                      category:product.categoryName,
                      subCategory:product.subCategoryName,
                      purchase_price:product.purchase_price,
                      selling_price:product.selling_price,
                      stock_quantity:product.stock_quantity,
                      note:product.note,
                      status:product.status,
                      image:product.image
                    };
                  });
          this.loadHide();
          this.modalReference = this.modalService.open(customerinfo);
  }
  
  fileChange(event: any) {
      this.fileList = event.target.files;
      // let filetypeToCompare = this.fileType.replace('*','');
      let hasFile = this.fileList && this.fileList.length > 0;
      if (hasFile) {
          var extension = this.fileList[0].name.substring(this.fileList[0].name.lastIndexOf('.'));
          // Only process image files.
          var validFileType = ".jpg , .png , .bmp";
          if (validFileType.toLowerCase().indexOf(extension) < 0) {
              alert("please select valid file type. The supported file types are .jpg , .png , .bmp");
            this.fileList = null;
            this.DisplayedText = "";
            return false;
          }
     
          if (this.fileList[0].size > 165535) {
              alert(`File size is more than 165 Kb`);
              this.fileList = null;
              this.DisplayedText = "";
              return false;
          }

          let multipleFile = this.fileList.length > 1;
          if (multipleFile) {
              this.DisplayedText = this.fileList.length + ' file(s) has been selected';
          }
          else {
              let file: File = this.fileList[0];
              this.DisplayedText = file.name;
          }
          this.onSelection.emit(this.fileList);
      }
  }

  insertAction(val){

    let formData:FormData = new FormData();
    if(this.fileList !=undefined){
      let file: File = this.fileList[0];
      formData.append('file', file, file.name);
    }
    formData.append('serial_number',this.product.serial_number);
    formData.append('name', this.product.name);
    formData.append('category', this.product.category);
    formData.append('subCategory', this.product.subCategory);
    formData.append('purchase_price', this.product.purchase_price);
    formData.append('selling_price', this.product.selling_price);
    formData.append('note', this.product.note);
    formData.append('status', this.product.status);

    if(val.id==''){
      this.dataService.save(formData)
          .pipe().subscribe(data =>{
              this.modalReference.close();
              this.dtTrigger = new Subject(); //  DataTable
              this.allProduct();
              this.alertService.success('Product Create successful', true);
          },error =>{
            this.alertService.error(error);
          });
    }else{
      formData.append('id', val.id);
      this.dataService.productUpdate(formData)
          .pipe().subscribe(data =>{
            this.modalReference.close();
            this.dtTrigger = new Subject(); //  DataTable
            this.allProduct();
            this.alertService.success('Product update successful', true);
          },error =>{
            this.alertService.error(error);
          });
    }
  }

  pdfExport(){
     window.open(appConfig.apiUrl+"/api/product-list-pdf", "_blank");
  }
  xlExport(){
     window.open(appConfig.apiUrl+"/api/product-list-excel", "_blank");
  }

  printTable() {
    /*var printContents = document.getElementById('table');
    var htmlToPrint = '' +
        '<style type="text/css">.action{display:none;}</style>';

      htmlToPrint += printContents.outerHTML;
      var popupWin = window.open('Print', '_blank');
      popupWin.document.open()
      popupWin.document.write('<html><head><link href="https://cdn.datatables.net/1.10.16/css/jquery.dataTables.min.css" rel="stylesheet" type="text/css" media="print"></head><body onload="window.print()">' + htmlToPrint + '</html>');

      popupWin.document.close();
               popupWin.focus();*/
  }
  
  loadShow(){
    this.showloding = true;
    this.lodingImage = false;
  }

  loadHide(){
    this.showloding = false;
    this.lodingImage = true;
  }
}
